module.exports = __webpack_public_path__ + "img/a3dfaed9873930d3f6582a8e4a038360.4724e5c1.png";